const defaultConfig = {
  api: {
    baseUrl: "https://uk-dev-api.tradekart.com",
  },
  ws: {
    baseUrl: "wss://uk-dev-api.tradekart.com",
  },
  env: "dev",
  locale: "en-GB",
  country: "UK",
  googleApiKey: "AIzaSyBA7deQW90be3BcQdL-8WY-Wbo1dzVSHiQ",
  showOrkestroChat: false,
  hsLiveChatUrl: "https://js.hs-scripts.com/143521055.js",
  appInsightsConnectionString:
    "InstrumentationKey=6615ba35-2cdb-4bb1-924b-c141424890ac;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=863b28d5-8388-45c3-adbc-1a3dcdf0e226",
};
export default defaultConfig;
